module.exports = __webpack_public_path__ + "static/media/student.21d096b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/student.png
// module id = 634
// module chunks = 0